// StatusTag.tsx
import { Tag } from "antd";
import { BRAND_TAG_STYLE } from "@/shared/lib/status-colors";
import { cn } from "@/shared/lib/utils";

interface StatusTagProps {
  status: string;
  label?: string;
  className?: string;
}

export function StatusTag({ status, label, className }: StatusTagProps) {
  return (
    <Tag
      className={cn("!m-0 !rounded !text-xs !leading-5", className)}
      style={{
        color: BRAND_TAG_STYLE.color,
        background: BRAND_TAG_STYLE.background,
        borderColor: BRAND_TAG_STYLE.border,
        padding: "0 7px",
      }}
    >
      {label ?? status.replace(/_/g, " ")}
    </Tag>
  );
}